<div class="footer__block">
  <div class="footer__heading heading heading_small">Buy images</div>
  <div class="footer__links">
    @for (category of categories$ | async; track category.id) {
      <a
        [appCategory]="category.name"
        [appCategoryPrice]="PricingFilterValues.PREMIUM"
      >
        Buy {{ category.name | lowercase }} images
      </a>
    }
  </div>
</div>
